import {
  SegmentedControl as Input,
  SegmentedControlProps,
  useMantineTheme,
} from "@mantine/core";
import { forwardRef, memo } from "react";

const SegmentedControl = forwardRef<HTMLInputElement, SegmentedControlProps>(
  (props, ref) => {
    const { mt = "md", ...rest } = props;

    const theme = useMantineTheme();

    return (
      <Input
        ref={ref}
        sx={{
          border: `1px solid ${theme.colors.secondary[0]}`,
          borderColor: `${theme.colors.secondary[0]} !important`,
          padding: 2,
          backgroundColor: theme.colors.secondary[4],
          color: rest.disabled
            ? theme.colors.light[7]
            : theme.colors.secondaryTextColor[6],
          ".mantine-SegmentedControl-active": {
            backgroundColor: theme.colors.primary[5],
            color: rest.disabled
              ? theme.colors.light[7]
              : theme.colors.primaryTextColor[5],
            boxShadow: "none !important",
            marginTop: 2,
            marginLeft: 2,
          },
          ".mantine-SegmentedControl-label": {
            padding: "2px 10px",
            color: theme.colors.secondaryTextColor[6],
          },
          ".mantine-SegmentedControl-labelActive": {
            color: theme.colors.primaryTextColor[6],
          },
        }}
        radius={"xl"}
        size={"sm"}
        {...rest}
      />
    );
  }
);
export default memo(SegmentedControl);
